const Functions = {
  addCommas(nStr) {
    nStr += "";
    var x = nStr.split(",");
    var x1 = x[0];
    var x2 = x.length > 1 ? "," + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  },

  create_UUID() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  },

  isObject(objValue) {
    return (
      objValue &&
      typeof objValue === "object" &&
      objValue.constructor === Object
    );
  },

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  },

  getFileExtension(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : null;
  },

  getDomainWithoutSubdomain() {
    let urlParts = location.hostname.includes(".")
      ? location.hostname.split(".")
      : [location.hostname];

    return urlParts
      .slice(0)
      .slice(-(urlParts.length === 4 ? 3 : 2))
      .join(".");
  },

  setCookie(cname, cvalue, days) {
    var dt, expires, domain;
    dt = new Date();
    dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + dt.toGMTString();
    domain = this.getDomainWithoutSubdomain();
    document.cookie = cname + "=" + cvalue + expires + "; domain=" + domain;
  },

  getCookie(cname) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");

      /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
      if (cname == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
      }
    }

    // Return null if not found
    return null;
  },

  deleteCookie(cname) {
    let domain = this.getDomainWithoutSubdomain();
    if (this.getCookie(cname)) {
      document.cookie =
        cname +
        "=" +
        (domain ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  },

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  },

  getBoldString(description, keywords) {
    let regHashtag = /#[A-Za-z0-9_]+/gm;
    let input = description;
    if (regHashtag.test(description)) {
      let matches = description.match(regHashtag);
      if (matches && matches.length) {
        matches.forEach((regValue) => {
          input = input.replace(
            regValue,
            `<a href="javascript:">${regValue}</a>`
          );
        });
      }
    }

    if (keywords && !["a", "href", "javascript"].includes(keywords)) {
      var words = keywords.includes(" ") ? keywords.split(" ") : [keywords];
      let result = input;
      words
        .filter((value, index, self) => {
          return self.indexOf(value) === index;
        })
        .forEach((word) => {
          if (word) {
            var reg = new RegExp(word, "gi");
            result = result.replace(reg, function (str) {
              return `<strong>${str}</strong>`;
            });
          }
        });
      return result;
    } else {
      return input;
    }
  },
};

Functions.install = function (Vue) {
  Vue.prototype.$func = Functions;
};
export default Functions;
